import { Typography, Card, CardContent } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconBulb } from "@tabler/icons-react";

export default function DocumentProcessingState() {
  return (
    <Card className="al-border al-border-gray-200">
      <CardContent className="al-py-20">
        <Stack direction="column" align="center" justify="center" gap="lg">
          <div className="al-rounded-full al-bg-blue-100 al-p-6">
            <IconBulb className="al-w-10 al-h-10 al-text-blue-600" />
          </div>
          <Stack direction="column" align="center" gap="sm">
            <Typography variant="h3" weight="semibold" className="al-text-gray-900">
              Document is being parsed
            </Typography>
            <Typography
              variant="body"
              size="regular"
              className="al-text-gray-600 al-text-center al-max-w-lg"
            >
              Your document is being processed to extract learnings. This may take some time
              depending on the document size. Check the History tab to view the processing status.
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
